import { DSNCSection } from 'shared-definitions/types'
import { ApiComponentSectionProps } from 'data-source/types.wp'
import { normalizeId } from 'shared-code/string'

export function ncSection(input: ApiComponentSectionProps): DSNCSection {
  return {
    resource: 'nc-section',
    anchor: normalizeId(input.anchor),
  }
}
